/**
 * Arthaus Sticky CTA bar — visibility controller
 * Phase: 10.0 (HD-P0-05)
 *
 * Markup: snippets/sticky-cta-bar.liquid. The bar slides up once its target
 * (the page's primary CTA) has scrolled ABOVE the viewport, and slides away
 * again when the target returns or the footer comes into view (so it never
 * sits on top of the footer's links). A target that is still below the fold —
 * the usual mobile first paint — keeps the bar hidden.
 *
 * Hidden state uses `inert` (not aria-hidden), so its button is neither
 * focusable nor announced while off-screen.
 *
 * Re-callable: window.ArthausStickyBar.init(scope) binds any bars inside
 * markup injected at runtime (e.g. the PDP frame swap). Already-bound bars are
 * skipped, and bars whose target was replaced are re-bound.
 */
window.ArthausStickyBar = window.ArthausStickyBar || (function () {
  'use strict';

  function bind(bar) {
    var targetId = bar.getAttribute('data-sticky-bar-target');
    var target = targetId && document.getElementById(targetId);
    if (!target || !('IntersectionObserver' in window)) return;
    if (bar._stickyTarget === target) return;           // already bound to this target
    if (bar._stickyObserver) bar._stickyObserver.disconnect();
    bar._stickyTarget = target;

    var footer = document.querySelector('footer');
    var queued = false;

    // State is read from live geometry, not from IntersectionObserver entries: an
    // observer only fires on a threshold crossing, so a target that starts below the
    // fold and is jumped past in one step (fast fling, scroll restoration on reload,
    // an anchor link) never "intersects" and the bar would stay hidden.
    function render() {
      queued = false;
      var pastTarget = target.getBoundingClientRect().bottom < 0;   // left through the top edge
      var f = footer && footer.getBoundingClientRect();
      var footerVisible = !!f && f.top < window.innerHeight && f.bottom > 0;
      var show = pastTarget && !footerVisible;
      bar.classList.toggle('translate-y-full', !show);
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(render);
    }

    var io = new IntersectionObserver(schedule, { threshold: 0 });
    io.observe(target);
    if (footer) io.observe(footer);
    // One passive, rAF-throttled listener catches jumps the observer never sees.
    if (!bar._stickyScroll) {
      bar._stickyScroll = function () { if (bar._stickySchedule) bar._stickySchedule(); };
      window.addEventListener('scroll', bar._stickyScroll, { passive: true });
    }
    bar._stickySchedule = schedule;
    bar._stickyObserver = io;
    render();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sticky-cta-bar]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  return { init: init };
})();
